module.exports = __webpack_public_path__ + "static/media/spring-boot.b4e74d85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/spring-boot.svg
// module id = 535
// module chunks = 0